export default {
  clickButton: 'click_button',
  clickLink: 'click_link',
  clickDropdown: 'click_dropdown',
  clickInput: 'click_input',
  clickIcon: 'click_icon',
  clickCardselection: 'click_cardselection',
  enterInput: 'enter_input',
  clickSubmitButton: 'click_submit_button'
}
